// extracted by mini-css-extract-plugin
export var entityChip = "_sr-0";
export var entityChipMissing = "_sr-1";